export default __webpack_public_path__ + "26baea2f9666eb4b74dec0232477ee6e.png";